/* ============================================================
   VISUAL STUDIO, Shopify theme JS
   Motion library + Ajax Cart API + Quiz modal
   ============================================================ */

(function () {
  'use strict';

  /* ─── nav scrolled state ──────────────────────────────────── */
  function initNavScroll() {
    const nav = document.querySelector('nav.site-nav');
    if (!nav) return;
    const onScroll = () => {
      if (window.scrollY > 30) nav.classList.add('scrolled');
      else nav.classList.remove('scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ─── inject corner brackets into .frame-corners ─────────── */
  function injectCorners() {
    document.querySelectorAll('.frame-corners').forEach(el => {
      if (el.querySelector('.fc-bl')) return;
      const bl = document.createElement('span');
      bl.className = 'fc-bl';
      const br = document.createElement('span');
      br.className = 'fc-br';
      el.appendChild(bl);
      el.appendChild(br);
    });
  }

  /* ─── word fade-in ───────────────────────────────────────── */
  function initFadeWords() {
    document.querySelectorAll('.fade-words').forEach(el => {
      if (el.dataset.split) return;
      el.dataset.split = '1';
      const out = [];
      let i = 0;
      el.childNodes.forEach(node => {
        if (node.nodeType === 3) {
          const tokens = node.textContent.split(/(\s+)/);
          tokens.forEach(tok => {
            if (/^\s+$/.test(tok)) out.push(tok);
            else if (tok.length) { out.push(`<span class="word" style="--i:${i}">${tok}</span>`); i++; }
          });
        } else if (node.nodeType === 1) {
          const tag = node.tagName.toLowerCase();
          out.push(`<${tag} class="word ${node.className||''}" style="--i:${i}">${node.innerHTML}</${tag}>`);
          i++;
        }
      });
      el.innerHTML = out.join('');
    });
  }

  /* ─── typewriter ─────────────────────────────────────────── */
  function initTypewriter() {
    document.querySelectorAll('.typewriter').forEach(el => {
      if (el.dataset.split) return;
      el.dataset.split = '1';
      const text = el.textContent;
      el.textContent = '';
      const frag = document.createDocumentFragment();
      [...text].forEach(ch => {
        const span = document.createElement('span');
        span.className = 'tw-char';
        span.textContent = ch === ' ' ? ' ' : ch;
        frag.appendChild(span);
      });
      const caret = document.createElement('span');
      caret.className = 'tw-caret';
      frag.appendChild(caret);
      el.appendChild(frag);
    });
  }

  /* ─── reveal observer ────────────────────────────────────── */
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.blur-in, .fade-words, .typewriter').forEach(el => el.classList.add('is-visible'));
      return;
    }
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        el.classList.add('is-visible');
        if (el.classList.contains('typewriter')) {
          const chars = el.querySelectorAll('.tw-char');
          chars.forEach((c, i) => setTimeout(() => { c.style.opacity = 1; }, i * 32));
        }
        obs.unobserve(el);
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -10% 0px' });
    document.querySelectorAll('.blur-in, .fade-words, .typewriter').forEach(el => obs.observe(el));
  }

  /* ═══════════════════════════════════════════════════════════
     SHOPIFY AJAX CART API
     Docs: https://shopify.dev/docs/api/ajax/reference/cart
     ═══════════════════════════════════════════════════════════ */
  const VS_CART = {
    async get() {
      const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      return r.json();
    },
    async add(variantId, quantity = 1, properties = {}) {
      const formData = { items: [{ id: variantId, quantity, properties }] };
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(formData)
      });
      const result = await r.json();
      if (!r.ok) throw result;
      await this.refresh();
      openDrawer();
      return result;
    },
    async update(line, quantity) {
      // line is 1-indexed
      const r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      const result = await r.json();
      await this.refresh();
      return result;
    },
    async refresh() {
      const cart = await this.get();
      updateBagCount(cart);
      renderDrawer(cart);
      window.dispatchEvent(new CustomEvent('vs:cart:updated', { detail: cart }));
      return cart;
    }
  };
  window.VS_CART = VS_CART;

  function updateBagCount(cart) {
    document.querySelectorAll('.nav-bag-count').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
    });
  }

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(0);
  }

  function openDrawer() {
    const o = document.getElementById('cartOverlay');
    const d = document.getElementById('cartDrawer');
    if (!o || !d) return;
    o.classList.add('active');
    d.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    const o = document.getElementById('cartOverlay');
    const d = document.getElementById('cartDrawer');
    if (!o || !d) return;
    o.classList.remove('active');
    d.classList.remove('active');
    document.body.style.overflow = '';
  }
  window.VS_DRAWER = { open: openDrawer, close: closeDrawer };

  function renderDrawer(cart) {
    const body = document.getElementById('cartBody');
    const foot = document.getElementById('cartFoot');
    if (!body) return;

    if (!cart.item_count) {
      body.innerHTML = `
        <div class="cd-empty">
          <div class="ce-icon">○</div>
          <p style="font-size:13px; letter-spacing:.04em;">Your bag is empty.</p>
          <a href="/collections/all" class="btn-text" style="margin-top:18px;">Browse the collection →</a>
        </div>`;
      foot.style.display = 'none';
      return;
    }
    foot.style.display = 'block';

    const lines = cart.items.map((it, i) => {
      const idx = i + 1; // Shopify lines are 1-indexed
      const img = it.image ? it.image.replace('.jpg', '_200x.jpg').replace('.png', '_200x.png').replace('.jpeg', '_200x.jpeg').replace('.webp', '_200x.webp') : '';
      const formatLine = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : (it.options_with_values ? it.options_with_values.map(o => o.value).join(' · ') : '');
      return `
        <div class="cd-line">
          <div class="cd-thumb" style="background-image:url('${img}')"></div>
          <div class="cd-info">
            <div class="cd-name">${it.product_title}</div>
            ${formatLine ? `<div class="cd-format">${formatLine}</div>` : ''}
            <div class="cd-qty-row">
              <button onclick="window.VS_CART.update(${idx}, ${it.quantity - 1})">−</button>
              <span>${it.quantity}</span>
              <button onclick="window.VS_CART.update(${idx}, ${it.quantity + 1})">+</button>
            </div>
          </div>
          <div class="cd-line-right">
            <div class="cd-line-price">${formatMoney(it.final_line_price)}</div>
            <button class="cd-remove" onclick="window.VS_CART.update(${idx}, 0)">Remove</button>
          </div>
        </div>`;
    }).join('');
    body.innerHTML = lines;

    const cfg = window.VS_THEME_CONFIG || {};
    const subtotalCents = cart.items_subtotal_price;
    const totalQty = cart.item_count;
    let bundleDiscountCents = 0;
    if (cfg.bundle_enabled && totalQty >= cfg.bundle_threshold) {
      bundleDiscountCents = Math.round(subtotalCents * (cfg.bundle_percent / 100));
    }
    const totalCents = subtotalCents - bundleDiscountCents;

    document.getElementById('cartSummary').innerHTML = `
      <div class="cd-row"><span>Subtotal</span><span>${formatMoney(subtotalCents)}</span></div>
      ${bundleDiscountCents ? `<div class="cd-row discount"><span>Bundle (${cfg.bundle_threshold}+), ${cfg.bundle_percent}% off</span><span>−${formatMoney(bundleDiscountCents)}</span></div>` : ''}
      <div class="cd-row total"><span>Total</span><span>${formatMoney(totalCents)}</span></div>
    `;
    if (bundleDiscountCents) {
      const note = `Bundle ${cfg.bundle_threshold}+, ${cfg.bundle_percent}% off applied automatically at checkout`;
      // Persist discount note via cart attributes (Shopify Scripts / discount code would actually apply it)
    }
  }

  /* ─── nav bag click ──────────────────────────────────────── */
  function initBag() {
    document.querySelectorAll('.nav-bag').forEach(b => {
      b.addEventListener('click', e => { e.preventDefault(); openDrawer(); });
    });
    const close = document.getElementById('cartClose');
    const overlay = document.getElementById('cartOverlay');
    if (close) close.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
  }

  /* ─── product form (PDP) ─────────────────────────────────── */
  function initProductForm() {
    const form = document.querySelector('[data-product-form]');
    if (!form) return;
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const variantId = form.querySelector('[name="id"]').value;
      const qty = parseInt(form.querySelector('[name="quantity"]').value, 10) || 1;
      const btn = form.querySelector('[data-add-to-bag]');
      if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
      try {
        await VS_CART.add(variantId, qty);
        if (btn) { btn.textContent = '✓ Added'; setTimeout(() => { btn.textContent = btn.dataset.label; btn.disabled = false; }, 1400); }
      } catch (err) {
        console.error(err);
        if (btn) { btn.textContent = 'Try again'; btn.disabled = false; }
      }
    });

    // Variant selector (radio buttons / format pickers)
    const variantInput = form.querySelector('[name="id"]');
    form.querySelectorAll('[data-variant-option]').forEach(btn => {
      btn.addEventListener('click', () => {
        form.querySelectorAll('[data-variant-option]').forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        variantInput.value = btn.dataset.variantOption;
      });
    });

    // Qty stepper
    const qtyInput = form.querySelector('[name="quantity"]');
    form.querySelector('[data-qty-down]') && form.querySelector('[data-qty-down]').addEventListener('click', () => {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
    });
    form.querySelector('[data-qty-up]') && form.querySelector('[data-qty-up]').addEventListener('click', () => {
      qtyInput.value = parseInt(qtyInput.value, 10) + 1;
    });

    // Buy now: add to cart, then redirect to /checkout
    const buyNow = form.querySelector('[data-buy-now]');
    if (buyNow) {
      buyNow.addEventListener('click', async () => {
        const variantId = form.querySelector('[name="id"]').value;
        const qty = parseInt(form.querySelector('[name="quantity"]').value, 10) || 1;
        await VS_CART.add(variantId, qty);
        window.location.href = '/checkout';
      });
    }
  }

  /* ─── quick add (collection cards) ──────────────────────── */
  function initQuickAdd() {
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      const variantId = btn.dataset.quickAdd;
      btn.disabled = true;
      const oldHtml = btn.innerHTML;
      btn.innerHTML = '✓';
      try {
        await VS_CART.add(variantId, 1);
        setTimeout(() => { btn.innerHTML = oldHtml; btn.disabled = false; }, 800);
      } catch (err) {
        btn.innerHTML = '!';
        setTimeout(() => { btn.innerHTML = oldHtml; btn.disabled = false; }, 1200);
      }
    });
  }

  /* ─── PDP gallery thumbs + arrows + swipe ───────────────── */
  function initGallery() {
    const mainImg  = document.getElementById('pdpMainImg');
    const thumbsEl = document.getElementById('pdpThumbs');
    const mainWrap = document.getElementById('pdpMain');
    if (!mainImg || !thumbsEl) return;

    const thumbList = () => Array.from(thumbsEl.querySelectorAll('.pdp-thumb'));

    function goTo(idx) {
      const ts = thumbList();
      if (!ts[idx]) return;
      ts.forEach(x => x.classList.remove('active'));
      ts[idx].classList.add('active');
      mainImg.style.opacity = '0';
      setTimeout(() => {
        mainImg.src    = ts[idx].dataset.full;
        mainImg.srcset = ts[idx].dataset.full;
        mainImg.style.opacity = '1';
      }, 150);
      ts[idx].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }

    function currentIdx() {
      return thumbList().findIndex(t => t.classList.contains('active'));
    }

    // Thumbnail click
    thumbsEl.addEventListener('click', e => {
      const t = e.target.closest('.pdp-thumb');
      if (!t) return;
      goTo(thumbList().indexOf(t));
    });

    // Inject arrow buttons into the main image wrapper
    if (mainWrap && thumbList().length > 1) {
      const btnStyle = 'position:absolute;top:50%;transform:translateY(-50%);background:rgba(10,10,10,0.55);border:none;color:#F4F1EB;width:36px;height:36px;border-radius:50%;font-size:18px;cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:10;transition:background 0.2s;backdrop-filter:blur(4px);';
      const prev = document.createElement('button');
      prev.setAttribute('aria-label', 'Previous image');
      prev.style.cssText = btnStyle + 'left:12px;';
      prev.innerHTML = '&#8592;';
      const next = document.createElement('button');
      next.setAttribute('aria-label', 'Next image');
      next.style.cssText = btnStyle + 'right:12px;';
      next.innerHTML = '&#8594;';
      mainWrap.style.position = 'relative';
      mainWrap.appendChild(prev);
      mainWrap.appendChild(next);
      prev.addEventListener('click', () => {
        const i = currentIdx();
        goTo(i > 0 ? i - 1 : thumbList().length - 1);
      });
      next.addEventListener('click', () => {
        const i = currentIdx();
        goTo(i < thumbList().length - 1 ? i + 1 : 0);
      });
      prev.addEventListener('mouseenter', () => { prev.style.background = 'rgba(10,10,10,0.85)'; });
      prev.addEventListener('mouseleave', () => { prev.style.background = 'rgba(10,10,10,0.55)'; });
      next.addEventListener('mouseenter', () => { next.style.background = 'rgba(10,10,10,0.85)'; });
      next.addEventListener('mouseleave', () => { next.style.background = 'rgba(10,10,10,0.55)'; });
    }

    // Hover: auto-cycle through every image on a timer, revert on mouse leave
    if (mainWrap && thumbList().length > 1 && window.matchMedia('(hover: hover)').matches) {
      let hoverTimer = null;
      let hoverIdx = 0;
      mainWrap.addEventListener('mouseenter', () => {
        const ts = thumbList();
        if (ts.length < 2) return;
        hoverIdx = currentIdx();
        hoverTimer = setInterval(() => {
          hoverIdx = (hoverIdx + 1) % ts.length;
          mainImg.src    = ts[hoverIdx].dataset.full;
          mainImg.srcset = ts[hoverIdx].dataset.full;
        }, 1600);
      });
      mainWrap.addEventListener('mouseleave', () => {
        clearInterval(hoverTimer);
        const ts = thumbList();
        const activeIdx = currentIdx();
        if (ts[activeIdx]) {
          mainImg.src    = ts[activeIdx].dataset.full;
          mainImg.srcset = ts[activeIdx].dataset.full;
        }
      });
    }

    // Touch swipe on main image
    if (mainWrap) {
      let _tx = 0;
      mainWrap.addEventListener('touchstart', e => { _tx = e.touches[0].clientX; }, { passive: true });
      mainWrap.addEventListener('touchend', e => {
        const diff = _tx - e.changedTouches[0].clientX;
        if (Math.abs(diff) < 40) return;
        const i = currentIdx();
        const ts = thumbList();
        if (diff > 0) goTo(i < ts.length - 1 ? i + 1 : 0);
        else          goTo(i > 0 ? i - 1 : ts.length - 1);
      }, { passive: true });
    }

    // Keyboard arrow navigation when gallery is focused
    mainWrap && mainWrap.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight') { const i = currentIdx(); goTo(i < thumbList().length - 1 ? i + 1 : 0); }
      if (e.key === 'ArrowLeft')  { const i = currentIdx(); goTo(i > 0 ? i - 1 : thumbList().length - 1); }
    });
  }

  /* ─── PDP accordions ─────────────────────────────────────── */
  // <details> handles itself natively, no JS needed

  /* ─── cart page line updates ─────────────────────────────── */
  function initCartPage() {
    const page = document.querySelector('[data-cart-page]');
    if (!page) return;
    page.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-cart-update]');
      if (!btn) return;
      const line = parseInt(btn.dataset.line, 10);
      const qty = parseInt(btn.dataset.qty, 10);
      await VS_CART.update(line, qty);
      window.location.reload();
    });
    page.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-cart-remove]');
      if (!btn) return;
      const line = parseInt(btn.dataset.line, 10);
      await VS_CART.update(line, 0);
      window.location.reload();
    });
  }

  /* ═══════════════════════════════════════════════════════════
     QUIZ MODAL
     ═══════════════════════════════════════════════════════════ */
  function initQuiz() {
    const overlay = document.getElementById('quizOverlay');
    if (!overlay) return;
    const close = document.getElementById('quizClose');
    const fill = document.getElementById('quizFill');
    const body = document.getElementById('quizBody');
    const result = document.getElementById('quizResult');
    const restart = document.getElementById('quizRestart');
    const steps = body.querySelectorAll('.quiz-step');
    const totalSteps = steps.length;
    let current = 0;
    const answers = {};

    function show(step) {
      steps.forEach(s => s.classList.remove('active'));
      body.querySelector(`[data-step="${step}"]`).classList.add('active');
      fill.style.width = `${((step + 1) / totalSteps) * 100}%`;
      body.style.display = 'block';
      result.classList.remove('active');
    }

    body.querySelectorAll('.quiz-option').forEach(opt => {
      opt.addEventListener('click', () => {
        const step = +opt.closest('.quiz-step').dataset.step;
        opt.parentElement.querySelectorAll('.quiz-option').forEach(o => o.classList.remove('selected'));
        opt.classList.add('selected');
        answers[step] = opt.dataset.v;
        opt.closest('.quiz-step').querySelector('.quiz-next').disabled = false;
      });
    });
    body.querySelectorAll('.quiz-next').forEach(btn => {
      btn.addEventListener('click', () => {
        if (current < totalSteps - 1) { current++; show(current); }
        else showResult();
      });
    });
    body.querySelectorAll('.quiz-back').forEach(btn => {
      btn.addEventListener('click', () => { if (current > 0) { current--; show(current); } });
    });

    function showResult() {
      const need = answers[1], inv = answers[2], stage = answers[0];
      let title, desc, badge, ctaLabel, ctaHref;
      if (need === 'all' || inv === 'handsoff') {
        title = 'The Growth Retainer'; badge = 'All three, one lead';
        desc = 'Brand, design, and marketing, built and run by one person, all pointing the same direction. The premium relationship for brands that want the whole throughline handled.';
        ctaLabel = 'Apply for the retainer →'; ctaHref = '/pages/creative-retainer';
      } else if (need === 'identity' || (stage === 'starting' && inv !== 'diy')) {
        title = 'Brand Strategy'; badge = 'The Decision';
        desc = "Who you are, who you're for, and why you're the only option. Clear enough that every design and marketing decision after it gets easier.";
        ctaLabel = 'See Brand Strategy →'; ctaHref = '/pages/services#brand-strategy';
      } else if (need === 'website' || need === 'visuals') {
        title = 'Design Strategy'; badge = 'The System';
        desc = 'A visual world and a custom Shopify experience that carry the brand and actually convert. Not a pretty template that says nothing.';
        ctaLabel = 'See Design Strategy →'; ctaHref = '/pages/services#design-strategy';
      } else if (stage === 'scaling') {
        title = 'Marketing Strategy'; badge = 'The Signal';
        desc = 'The system that gets the right people to see it, trust it, and buy, on repeat. Ads, email, and content built to compound.';
        ctaLabel = 'See Marketing Strategy →'; ctaHref = '/pages/services#marketing-strategy';
      } else {
        title = 'Start with a Brand Review'; badge = 'Best first step';
        desc = "Not sure where the problem is? A top to bottom diagnostic of your brand, site, and funnel, with a clear, prioritized plan that points you to the right next step.";
        ctaLabel = 'Book a Brand Review →'; ctaHref = '/pages/brand-review';
      }
      document.getElementById('resultTitle').textContent = title;
      document.getElementById('resultDesc').textContent = desc;
      document.getElementById('resultBadge').textContent = badge;
      const cta = document.getElementById('resultCta');
      if (cta) { cta.textContent = ctaLabel; cta.setAttribute('href', ctaHref); }
      body.style.display = 'none';
      fill.style.width = '100%';
      result.classList.add('active');
    }
    if (restart) restart.addEventListener('click', () => {
      current = 0; Object.keys(answers).forEach(k => delete answers[k]);
      body.querySelectorAll('.quiz-option.selected').forEach(o => o.classList.remove('selected'));
      body.querySelectorAll('.quiz-next').forEach(b => b.disabled = true);
      show(0);
    });

    if (close) close.addEventListener('click', () => { overlay.classList.remove('active'); document.body.style.overflow = ''; });
    overlay.addEventListener('click', e => { if (e.target === overlay) { overlay.classList.remove('active'); document.body.style.overflow = ''; } });

    window.VS_QUIZ = {
      open() { overlay.classList.add('active'); document.body.style.overflow = 'hidden'; },
      close() { overlay.classList.remove('active'); document.body.style.overflow = ''; }
    };
  }

  function initQuizTriggers() {
    document.querySelectorAll('[data-quiz-open]').forEach(b => {
      b.addEventListener('click', e => { e.preventDefault(); window.VS_QUIZ && window.VS_QUIZ.open(); });
    });
  }

  /* ─── mobile nav drawer ──────────────────────────────────── */
  function initMobileNav() {
    const hamburger = document.querySelector('.nav-hamburger');
    const overlay   = document.getElementById('mobileNavOverlay');
    const drawer    = document.getElementById('mobileDrawer');
    const closeBtn  = document.getElementById('mobileDrawerClose');
    if (!hamburger || !drawer) return;

    function openMobileNav() {
      drawer.classList.add('active');
      overlay && overlay.classList.add('active');
      hamburger.setAttribute('aria-expanded', 'true');
      drawer.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
    }
    function closeMobileNav() {
      drawer.classList.remove('active');
      overlay && overlay.classList.remove('active');
      hamburger.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    hamburger.addEventListener('click', () => {
      const isOpen = hamburger.getAttribute('aria-expanded') === 'true';
      isOpen ? closeMobileNav() : openMobileNav();
    });
    if (closeBtn)  closeBtn.addEventListener('click',  closeMobileNav);
    if (overlay)   overlay.addEventListener('click',   closeMobileNav);

    // Close on link click (navigation) — quiz triggers handle their own logic
    drawer.querySelectorAll('.md-link:not([data-quiz-open])').forEach(a => {
      a.addEventListener('click', closeMobileNav);
    });
    // Quiz trigger inside drawer
    drawer.querySelectorAll('[data-quiz-open]').forEach(a => {
      a.addEventListener('click', (e) => {
        e.preventDefault();
        closeMobileNav();
        setTimeout(() => { window.VS_QUIZ && window.VS_QUIZ.open(); }, 320);
      });
    });

    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('active')) closeMobileNav();
    });
  }

  /* ─── footer accordion (mobile) ─────────────────────────── */
  function initFooterAccordion() {
    document.querySelectorAll('.bsf-col-toggle').forEach(toggle => {
      toggle.addEventListener('click', () => {
        const col     = toggle.closest('.bsf-col');
        const chevron = toggle.querySelector('.bsf-chevron');
        if (!col) return;
        const isOpen  = col.classList.contains('open');
        // Close all open columns first
        document.querySelectorAll('.bsf-col.open').forEach(c => {
          c.classList.remove('open');
          const ch = c.querySelector('.bsf-chevron');
          if (ch) ch.textContent = '+';
        });
        // Open the clicked one (unless it was already open)
        if (!isOpen) {
          col.classList.add('open');
          if (chevron) chevron.textContent = '−';
        }
      });
    });
  }

  /* ─── newsletter form ────────────────────────────────────── */
  function initNewsletter() {
    document.querySelectorAll('[data-newsletter-form]').forEach(form => {
      form.addEventListener('submit', () => {
        // Shopify's customer create form handles the actual submission server-side
        const btn = form.querySelector('button[type="submit"]');
        if (btn) { setTimeout(() => { btn.textContent = '✓ In'; }, 100); }
      });
    });
  }

  /* ─── Product card image hover-cycle (collection, related, YMAL) ─── */
  function initCardImageCycle() {
    if (!window.matchMedia('(hover: hover)').matches) return;
    const stacks = document.querySelectorAll('.pc-image-stack[data-hover-cycle]');
    stacks.forEach(stack => {
      if (stack.dataset.cycleBound) return;
      stack.dataset.cycleBound = 'true';
      const imgs = Array.from(stack.querySelectorAll('.pc-image'));
      if (imgs.length < 2) return;
      const card = stack.closest('.product-card') || stack;
      let idx = 0;
      let timer = null;
      card.addEventListener('mouseenter', () => {
        timer = setInterval(() => {
          imgs[idx].classList.remove('pc-image--active');
          idx = (idx + 1) % imgs.length;
          imgs[idx].classList.add('pc-image--active');
        }, 1600);
      });
      card.addEventListener('mouseleave', () => {
        clearInterval(timer);
        imgs.forEach((im, i) => im.classList.toggle('pc-image--active', i === 0));
        idx = 0;
      });
    });
  }

  /* ─── boot ──────────────────────────────────────────────── */
  function boot() {
    injectCorners();
    initFadeWords();
    initTypewriter();
    initReveal();
    initNavScroll();
    initBag();
    initProductForm();
    initQuickAdd();
    initGallery();
    initCardImageCycle();
    initCartPage();
    initQuiz();
    initQuizTriggers();
    initMobileNav();
    initFooterAccordion();
    initNewsletter();
    VS_CART.refresh().catch(() => {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init on Shopify customizer section reload
  document.addEventListener('shopify:section:load', () => {
    injectCorners();
    initFadeWords();
    initTypewriter();
    initReveal();
    injectCorners();
    initMobileNav();
    initFooterAccordion();
    initCardImageCycle();
  });
})();
